<template>

    <form v-on:submit.prevent="">

        <BaseInputFloatinglabel v-model="form.name"
                                placeholder="Name"
                                icon="tags"
                                type="text"/>

        <div class="action">
          <BaseButton v-if="type === 'create'"
                       :loading="creating"
                       :disabled="checkForm || creating"
                       icon="plus"
                       label="Erstellen"
                       :submit="true"
                       @click="create"/>
          <BaseButton v-if="hasManagerRole && type === 'edit'"
                       :loading="removing"
                       :disabled="removing"
                       icon="trash"
                       label="Löschen"
                       :remove="true"
                       @click="remove"/>
          <BaseButton v-if="type === 'edit'"
                       :loading="updating"
                       :disabled="checkForm || updating"
                       icon="save"
                       label="Speichern"
                       :submit="true"
                       @click="update"/>
        </div>

    </form>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  name: 'MediacontactProductTypeForm',
  props: ['mediacontactProductType', 'type'],
  data () {
    return {
      form: {},
      creating: false,
      updating: false,
      removing: false
    }
  },
  created () {
    this.form = cloneDeep(this.mediacontactProductType)
  },
  methods: {
    async create () {
      try {
        this.creating = true
        const response = await this.createMediacontactProductType({ data: this.form })
        this.$vfm.hide('mediacontact-product-type-create')
        this.$toasted.success('Produktart ' + response.data.name + ' erstellt', { icon: 'fas fa-tags' })
        this.creating = false
        await this.getMediacontactProductTypes()
      } catch (error) {
        this.creating = false
      }
    },
    async update () {
      try {
        this.updating = true
        const response = await this.updateMediacontactProductType({ id: this.form.id, data: this.form })
        this.$vfm.hide('mediacontact-product-type-edit')
        this.$toasted.success('Produktart ' + response.data.name + ' aktualisiert', { icon: 'fas fa-tags' })
        this.updating = false
        await this.getMediacontactProductType({ id: this.form.id })
      } catch (error) {
        this.updating = false
      }
    },
    async remove () {
      try {
        this.removing = true
        await this.deleteMediacontactProductType({ id: this.form.id })
        this.$vfm.hide('mediacontact-product-type-edit')
        this.$toasted.success('Produktart gelöscht', { icon: 'fas fa-tags' })
        this.removing = false
        await this.getMediacontactProductTypes()
      } catch (error) {
        this.removing = false
      }
    },
    ...mapActions({
      getMediacontactProductType: 'mediacontactProductTypes/fetchSingle',
      getMediacontactProductTypes: 'mediacontactProductTypes/fetchList',
      createMediacontactProductType: 'mediacontactProductTypes/create',
      updateMediacontactProductType: 'mediacontactProductTypes/replace',
      deleteMediacontactProductType: 'mediacontactProductTypes/destroy'
    })
  },
  computed: {
    checkForm () {
      return !(this.form.name)
    },
    ...mapGetters({
      hasManagerRole: 'auth/hasManagerRole'
    })
  }
}
</script>
